import { render, staticRenderFns } from "./SortableItem.vue?vue&type=template&id=45fcaf0d&scoped=true&"
import script from "./SortableItem.vue?vue&type=script&lang=js&"
export * from "./SortableItem.vue?vue&type=script&lang=js&"
import style0 from "./SortableItem.vue?vue&type=style&index=0&id=45fcaf0d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fcaf0d",
  null
  
)

export default component.exports